__turbopack_context__.v({
  "close": "SoqsSG_close",
  "content": "SoqsSG_content",
  "header": "SoqsSG_header",
  "modal": "SoqsSG_modal",
  "modal--close": "SoqsSG_modal--close",
  "modal--open": "SoqsSG_modal--open",
  "overlay": "SoqsSG_overlay",
  "overlay--close": "SoqsSG_overlay--close",
  "overlay--open": "SoqsSG_overlay--open",
});
